import { PlusIcon } from '@heroicons/react/24/outline';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from 'components/layout/popover';
import { useState } from 'react';
import { ComparisonSystemPick } from './comparison-system-pick';
import ComparisonSystemPicker, {
  ComparisonSystemPickerProps
} from './comparison-system-picker';

export default function AddSystemColumnPopover({
  onPick,
  ...pickerProps
}: ComparisonSystemPickerProps) {
  const [open, setOpen] = useState(false);

  const handlePick = (pick: ComparisonSystemPick) => {
    setOpen(false);
    onPick(pick);
  };

  return (
    <Popover open={open} onOpenChange={setOpen} placement='bottom'>
      <PopoverTrigger
        onClick={() => setOpen((v) => !v)}
        aria-label='Add a system to compare'
        className='flex h-full w-full cursor-pointer flex-col items-center justify-center gap-1.5 rounded-lg border-2 border-dashed border-gray-300 p-4 text-gray-500 hover:border-blue-400 hover:bg-blue-50 hover:text-blue-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500'
      >
        <PlusIcon className='h-6 w-6' />
        <span className='text-sm font-semibold'>Add System to Compare</span>
      </PopoverTrigger>
      <PopoverContent className='z-50 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl focus:outline-none'>
        <ComparisonSystemPicker {...pickerProps} onPick={handlePick} />
      </PopoverContent>
    </Popover>
  );
}
